import { CircleAlert, CircleCheck, CircleHelp } from "lucide-react";

// Estado da quota da escrita verificada, antes de pedir: diz se se pode gerar
// agora e, se não, quando volta a haver quota. Não gasta quota.
export const VerifiedQuotaStatus = ({ quota }) => {
        if (!quota) return null;
        const engines = (quota.engines || [])
                .map((e) => `${e.engine}${e.used_percent != null ? ` ${Math.round(e.used_percent)}% da ${e.window}` : ""}`)
                .join(" · ");
        if (quota.available === false) {
                const b = quota.blocked_by || {};
                return (
                        <p className="mb-4 flex items-start gap-2 text-sm text-[var(--deception)]" data-testid="verified-quota-status">
                                <CircleAlert size={16} className="mt-0.5 shrink-0" />
                                <span>
                                        Escrita verificada indisponível: {b.engine || "motor"} ({b.window || "quota"}
                                        {b.used_percent != null ? `, ${Math.round(b.used_percent)}% usados` : ""}).
                                        {b.window === "sessão terminada" ? " Inicia sessão de novo no admin do Infinitum ou muda o motor ativo." : ""}
                                        {b.resets_at ? ` Volta a haver às ${b.resets_at}.` : ""} Os pedidos feitos agora são recusados.
                                </span>
                        </p>
                );
        }
        if (quota.available === true) {
                return (
                        <p className="mb-4 flex items-start gap-2 text-xs text-[var(--ink-soft)]" data-testid="verified-quota-status">
                                <CircleCheck size={14} className="mt-0.5 shrink-0 text-[var(--truth)]" />
                                <span>
                                        Escrita verificada disponível{engines ? ` (${engines})` : ""}; cada dossiê leva cerca de {quota.eta || "10–12 min"}.
                                </span>
                        </p>
                );
        }
        return (
                <p className="mb-4 flex items-start gap-2 text-xs text-[var(--ink-faint)]" data-testid="verified-quota-status">
                        <CircleHelp size={14} className="mt-0.5 shrink-0" />
                        <span>{quota.message || "Estado da quota da escrita verificada desconhecido."}</span>
                </p>
        );
};
